import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Alarme, IAlarme} from '../../_models/Alarme';
import {BaseHubService} from './base-hub.service';
import {Store} from '@ngrx/store';
import {MainStoreState} from '../../_store/mainStoreState';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {IBaseObject} from '../../_models/BaseObject';
import {setAlarmesAction} from '../../_store/AlarmeStore/alarme.store';

@Injectable({
  providedIn: 'root',
})
export class AlarmeService extends BaseHubService<Alarme> {
  constructor(
    http: HttpClient,
    private store: Store<MainStoreState>,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super(
      'alarmes',
      'hubs/alarmesHub',
      'Alarmes',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  async send(alarme: Alarme): Promise<void> {
    try {
      await this.connection.invoke('SendMessage', JSON.stringify(alarme));
    } catch (error) {
      console.error(error);
    }
  }

  demanderQuittance(alarme: Alarme): Observable<void | undefined> {
    if (!alarme.id) {
      throw new Error(`L'identifiant id de l'élément est introuvable.`);
    }

    const al = alarme.format();
    al.idEtat = 2;
    return this.editState(al, 'edition-quittancement');
  }

  demanderAcquittement(alarme: Alarme): Observable<void | undefined> {
    if (!alarme.id) {
      throw new Error(`L'identifiant id de l'élément est introuvable.`);
    }

    const al = alarme.format();
    al.idEtat = 4;
    return this.editState(al, 'edition-acquittement');
  }

  private editState(
    alarme: IAlarme,
    endpoint: string
  ): Observable<void | undefined> {
    return this.http
      .post<void>(`${this.baseUrl}/${endpoint}`, alarme)
      .pipe(catchError((error) => this.handleError(error)));
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(setAlarmesAction({payload: data as Alarme[]}));
  }
}
